// extracted by mini-css-extract-plugin
export default {"page":"legislation_page__AQDc7","wrapper":"legislation_wrapper__LyGC9","accordion-button":"legislation_accordion-button__YRxyS","buttons":"legislation_buttons__08h2X"};